import { useWindowDimensions } from "@songtradr/design-language";

export const useContentMargins = (
  contentMaxWidth = 1440,
  targetMargin = "max(1rem, min(7vw, 6rem))",
): [string, boolean] => {
  const { width: screenWidth } = useWindowDimensions();

  const atContentMax = screenWidth >= contentMaxWidth;

  const maxWidthCompensation = `calc(${screenWidth}px - ${contentMaxWidth}px)`;
  const calculatedMargin = atContentMax
    ? `max(calc(${maxWidthCompensation} / 2), ${targetMargin})`
    : targetMargin;

  return [calculatedMargin, atContentMax];
};
